import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProductCard = ({ product, index }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.05 }}
      className="group h-full"
    >
      <Link 
        to={`/product/${product.id}`} 
        className="block h-full focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ultramarine focus-visible:ring-offset-4 rounded-sm"
        aria-label={`View ${product.title} by ${product.artist}`}
      >
        <div className="relative aspect-[3/4] overflow-hidden bg-gray-100 mb-5">
          <img 
            src={product.image} 
            alt={product.title} 
            className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/5 transition-colors duration-500" />
          
          <div className="absolute bottom-0 left-0 w-full p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-500 bg-white/95 backdrop-blur-sm shadow-lg">
            <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-center text-charcoal">View Experience</p>
          </div>
        </div>
        
        <div className="space-y-1 text-center md:text-left px-2">
          <div className="flex flex-col md:flex-row md:justify-between md:items-baseline gap-1">
            <h3 className="font-serif text-lg md:text-xl text-charcoal group-hover:text-ultramarine transition-colors">{product.title}</h3>
            <span className="text-sm font-semibold text-ultramarine">${product.price}</span>
          </div>
          <p className="text-xs tracking-widest uppercase text-gray-500 font-medium">{product.artist}</p>
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;